import { themesRebrand, Theme } from '@redis-ui/styles';

export const themeUi: Theme = themesRebrand.light;
